import type { VoidFunctionComponent } from 'react';

import FormLabel from '../../../generic/Forms/FormLabel';
import Select from '../../../generic/Select/Select';
import type { SelectOption } from '../../../../types';

type Props = {
  isLoading: boolean;
  selectedOption: SelectOption | null;
  options: SelectOption[];
  onChange: (option: SelectOption | null) => void;
};

/**
 * FileViewerFileSelector is a labeled Select dropdown
 * which allows the user to determine which
 */
const FileViewerFileSelector: VoidFunctionComponent<Props> = ({
  isLoading,
  selectedOption,
  options,
  onChange,
}) => (
  <FormLabel label="File matches">
    <Select
      value={selectedOption}
      options={options}
      isLoading={isLoading}
      onChange={onChange}
    />
  </FormLabel>
);

export default FileViewerFileSelector;
